const styles = {
	"bottom-button-wrapper": "nitro-ui__BottomButton-module__bottom-button-wrapper",
	"bottom-button": "nitro-ui__BottomButton-module__bottom-button",
	"bottom-button-inner": "nitro-ui__BottomButton-module__bottom-button-inner",
	"keyboard-open": "nitro-ui__BottomButton-module__keyboard-open"};

export { styles as default };
